var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5292 6.61081C31.2437 6.1161 30.8348 5.70383 30.3425 5.41422C29.8501 5.12461 29.2911 4.96755 28.72 4.95835H7.56833L6.60989 1.22379C6.51306 0.863286 6.29702 0.546189 5.99695 0.324144C5.69689 0.102099 5.33049 -0.0118097 4.95742 0.000969136H1.65247C1.21421 0.000969136 0.793897 0.175067 0.483998 0.484963C0.174099 0.79486 0 1.21517 0 1.65343C0 2.09169 0.174099 2.512 0.483998 2.8219C0.793897 3.13179 1.21421 3.30589 1.65247 3.30589H3.70154L8.26237 20.2601C8.3592 20.6206 8.57525 20.9377 8.87531 21.1598C9.17537 21.3818 9.54177 21.4957 9.91484 21.483H24.7871C25.0923 21.482 25.3912 21.3966 25.6508 21.2362C25.9104 21.0758 26.1205 20.8466 26.2578 20.5741L31.6779 9.73396C31.9128 9.24155 32.0222 8.69864 31.9963 8.15369C31.9703 7.60873 31.8098 7.07867 31.5292 6.61081ZM23.7626 18.178H11.1707L8.47719 8.26327H28.72L23.7626 18.178Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08906 29.7464C10.458 29.7464 11.5678 28.6367 11.5678 27.2677C11.5678 25.8988 10.458 24.7891 9.08906 24.7891C7.72011 24.7891 6.61035 25.8988 6.61035 27.2677C6.61035 28.6367 7.72011 29.7464 9.08906 29.7464Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6125 29.7464C26.9815 29.7464 28.0912 28.6367 28.0912 27.2677C28.0912 25.8988 26.9815 24.7891 25.6125 24.7891C24.2435 24.7891 23.1338 25.8988 23.1338 27.2677C23.1338 28.6367 24.2435 29.7464 25.6125 29.7464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyer);
export default __webpack_public_path__ + "static/media/Buyer.8ebccf33d4e6adc2da125f4ba56d3f19.svg";
export { ForwardRef as ReactComponent };